import template from './reset_atm_code.html';
import controller from './reset_atm_code.controller';
import './reset_atm_code.scss';

let resetAtmCodeComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
};

export default resetAtmCodeComponent;


// WEBPACK FOOTER //
// ./client/app/components/reset_atm_code/reset_atm_code.component.js